import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardholderService } from '@app-services/cardholder.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from '@app-services/client.service';
import { GroupService } from '@app-services/group.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-entity-modal',
  templateUrl: './remove-entity-modal.component.html',
  styleUrls: ['./remove-entity-modal.component.scss']
})
export class RemoveEntityModalComponent implements OnInit {

  id: string;
  type: string;
  name: string;
  loading: boolean;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private clientService: ClientService,
    private groupService: GroupService,
    private cardholderService: CardholderService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RemoveEntityModalComponent>,
  ) {
    this.name = data.name;
    this.id = data.id;
    this.type = data.type;
  }

  ngOnInit(): void {

  }


  close(): void {
    this.dialogRef.close(false);
  }

  remove(): void {
    this.loading = true;
    let removalObs;
    switch (this.type) {
      case 'CLIENT':
      case 'CLIENT_INDIVIDUAL':
      case 'CLIENT_ENTERPRISE':
        removalObs = this.clientService.remove(this.id);
        break;
      case 'GROUP':
        removalObs = this.groupService.remove(this.id);
        break;
      case 'CARDHOLDER':
        removalObs = this.cardholderService.remove(this.id);
        break;
    }
    removalObs.subscribe(resp => {
      if (resp.success) {
        this.toastr.success(this.translate.instant('removeEntity.successMessage.' + this.type, { name: this.name }));

        this.loading = false;
        this.close();

        let destination;
        switch (this.type) {
          case 'CLIENT':
            destination = "client";
            break;
          case 'GROUP':
            destination = "group";
            break;
          case 'CARDHOLDER':
            destination = "cardholder";
            break;
        }

        if (destination) {
          this.router.navigate(['admin', destination]);
        } else {
          this.loading = false;
          this.close();
        }
      } else {
        this.translate.get('removeEntity.errorMessage').subscribe(m => {
          this.toastr.error(m);
        })
      }
    })
  }
}
